<template>
	<div class="selection-sort">
    <!--  搜索参数列表  -->
    <Screen ref="screen" @closeAll="closeAll"></Screen>
    <!--  工程分类  -->
    <secondCategory v-if="config.includes('secondCategory')" ref="secondCategory"></secondCategory>
    <!--  团队类型  -->
    <teamType v-if="config.includes('teamType')" ref="teamType"></teamType>
    <!--  工种名称  -->
    <workType v-if="config.includes('workType')" ref="workType"></workType>
    <!--  团队规模  -->
    <teamSize v-if="config.includes('teamSize')&&teamSizeType!==''" ref="teamSize"></teamSize>
    <!--  行业类别+专业分类  -->
    <industryType v-if="config.includes('industryType')" ref="industryType"></industryType>
    <!--  工程公司-资质筛选  -->
    <aptitudeType v-if="config.includes('aptitudeType')" ref="aptitudeType"></aptitudeType>
    <!--  企业类型  -->
    <enterpriseType v-if="config.includes('enterpriseType')" ref="enterpriseType" :laborAddress='laborAddress'></enterpriseType>
    <!--  报名结束时间  -->
    <timeList v-if="config.includes('timeList')" ref="timeList"></timeList>
    <!-- 临时用工-薪资方式 -->
    <salaryType v-if="config.includes('salaryType')" ref="salaryType"></salaryType>
    <!--  筛选  -->
    <recruitType v-if="config.includes('recruitType')" ref="recruitType"></recruitType>
    <!--  综合筛选  -->
    <workyearAndLevel v-if="config.includes('workyearAndLevel')" ref="workyearAndLevel"></workyearAndLevel>
    <!--  更多筛选  -->
    <verticalTypeAndPice v-if="config.includes('verticalTypeAndPice')" ref="verticalTypeAndPice"></verticalTypeAndPice>
    <!--  省份  -->
    <areacodeList v-if="config.includes('areacodeList')" ref="areacodeList"></areacodeList>
    <!--  施工队-综合筛选  -->
    <teamScreen v-if="config.includes('teamScreen')&&teamSizeType===0" ref="teamScreen"></teamScreen>
    <!--  劳务公司-综合筛选  -->
    <laborScreen v-if="config.includes('laborScreen')" ref="laborScreen"></laborScreen>
    <!--  工程公司-综合筛选  -->
    <engineeringScreen v-if="config.includes('engineeringScreen')" ref="engineeringScreen"></engineeringScreen>
    <!--  所在地区  -->
    <newLocationAddress v-if="config.includes('locationAddress')" ref="locationAddress" :laborAddress='laborAddress'></newLocationAddress>
  </div>
</template>

<script>
	export default {
		name: "SelectionSort",
    components: {
      Screen: () => import("./list/screen"),
      secondCategory: () => import("./list/secondCategory"),
      workType: () => import("./list/workType"),
      teamType: () => import("./list/teamType"),
      teamSize: () => import("./list/teamSize"),
      industryType: () => import("./list/industryType"),
      enterpriseType: () => import("./list/enterpriseType"),
      timeList: () => import("./list/timeList"),
      recruitType: () => import("./list/recruitType"),
      workyearAndLevel: () => import("./list/workyearAndLevel"),
      verticalTypeAndPice: () => import("./list/verticalTypeAndPice"),
      areacodeList: () => import("./list/areacodeList"),
      newLocationAddress: () => import("./list/newLocationAddress"),
      salaryType: () => import("./list/salaryType"),
      teamScreen: () => import("./list/teamScreen"),
      laborScreen: () => import("./list/laborScreen"),
      aptitudeType: () => import("./list/aptitudeType"),
      engineeringScreen: () => import("./list/engineeringScreen"),
    },
		props: {
		  config: {
        type: Array,
        default(){
          return []
          /*return ['secondCategory','workType','teamType','teamSize','industryType','industryTypeS','enterpriseType','timeList',
          'recruitType','workyearAndLevel','verticalTypeAndPice','areacodeList','locationAddress']*/
        },
        firstCategoryNo:{
          type:String,
          default:''
        }
      },
      //工程分类最多显示几层
      secondCategoryi:{
		    type:[Number,String],
        default:6
      },
      //是否允许工程分类读取历史记录
      getquery:{
        type:Boolean,
        default:false
      },
      //团队规模中查询类型
      teamSizeType:{
        type:[Number,String],
        default:0
      },
      //劳务公司的注册地区
      laborAddress:{
        type:Boolean,
        default:false
      },
		},
		data() {
			return {}
		},
		methods: {
      closeAll(){
        let t=this;
        this.config.forEach(v=>{
          t.$refs.screen[v]=[];
          t.$refs[v]&&t.$refs[v].closeall();
        })
      },
      change(obj){ 
        this.$emit('changeobj',obj)
      }
		},
	}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
/deep/.bgff {
  color: #fff;
}
/deep/.el-input__inner{
  border-radius: 0px ;
  padding-left: 10px;
  color: #000;
  width: 150px;
  height: 30px;
  font-size: 14px;
}
/deep/.demo-form-inline{
  height: 46px;
  display: flex;
  align-items: center;
}
/deep/.select-input {
  width: 150px;
  height: 40px;
  padding: 10px 0 10px 10px;
  box-sizing: border-box;
}
/deep/.el-input__inner:focus{
  border-color: #b79255;
}
/deep/.el-select .el-input.is-focus .el-input__inner{
  border-color: #b79255;
}
/deep/.el-cascader .el-input.is-focus .el-input__inner{
  border-color: #b79255;
}
/deep/.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{
  border-color: #b79255;
}
/deep/.el-select .el-input__inner:focus{
  border-color: #b79255;
}
/deep/.el-select .el-input .el-select__caret{
  height: 30px;
  line-height: 30px;
}
/*展开收起*/
</style>
<style lang="scss" rel="stylesheet/scss">

.selection-sort {
  width: 100%;
  user-select:none;

  .menu_box {
    width: 1198px;
    margin: 0 auto;
    background: #ffffff;
    position: relative;
    border-left: 1px solid #e4e7ed;
    border-right: 1px solid #e4e7ed;
    &:first-of-type{
      border-top: 1px solid #E4E7ED ;
    }
    .nocheck {
      background: no-repeat url("../../assets/screen/bg-nocheck.png") left
      top;
    }

    .check {
      background: no-repeat url("../../assets/screen/bg-check.png") left top;
      z-index: 5;
    }

    .tag-inner {
      width: 155px;
      height: 50px;
      line-height: 50px;
      position: absolute;
      top: -52px;
      text-indent: 30px;
      cursor: pointer;
    }

    .talents {
      right: 260px;
      z-index: 3;
    }

    .construction-team {
      right: 130px;
      z-index: 2;
    }

    .company {
      right: 0;
      z-index: 1;
    }

    .title_category {
      width: 130px;
      text-align: center;
      /*height: 35px;*/
      color: #666666;
      font-weight: 400;
      font-size: 14px;
      /*padding-left: 16px;*/
      background-color: #f5f7fa;
    }
    .title_shaixuan {
      width: 130px;
      text-align: center;
      color: #666666;
      font-weight: 400;
      font-size: 14px;
      line-height: 46px;
      background-color: #f5f7fa;
    }

    .province {
      height: 40px;
      overflow: hidden;
    }

    .sort {
      height: 40px;
      overflow: hidden;
    }
    .sortEQU {
      height: 48px;
      overflow: hidden;
    }
    .sortpRISE {
      height: 48px;
      overflow: hidden;
    }


  }
  > div{
    .menu_box{
      border-bottom: 1px dashed #e4e7ed;
    }

  }
  .classified_content {
    position: relative;
    overflow: hidden;
    flex: 1;
    margin-left: 6px;
    padding-right: 50px;
    > span {
      margin:8px 0 0 4px;
      padding:0 13px;
      height: 30px;
      font-size: 14px;
      color: #333;
      display: inline-block;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .el-select {
      margin-right: 15px;
    }
    .unfold {
      position: relative;
      float: right;
      right: -50px;
      top:15px;
      width: 50px;
      font-size: 12px;
      color: #666;
      cursor: pointer;
      i {
        margin-left: 5px;
        transform: translateY(1px);
      }
    }
    .unfold:hover,.unfold-red {
      color: #ff6600;
    }
  }
  .allBox {
    border-top: none;
  }

  div:not(:last-child) .borderBottomDashed{
    border-bottom: 1px dashed #e4e7ed;
  }
  div:last-child .borderBottomDashed{
    border-bottom: 1px solid #e4e7ed;
  }

  .paddingAll20 {
    /*padding: 5px 20px 0;*/
    box-sizing: border-box;
  }

  .pitch_on {
    background: #b79255;
    color: #ffffff !important;
    border-radius: 4px;
  }

  .teamType_on {
    background: #0286df;
    color: #ffffff !important;
    border-radius: 4px;
  }
  .teamStatus_on {
    background: #0286df;
    color: #ffffff !important;
    border-radius: 4px;
  }
}

</style>
